module.exports = __webpack_public_path__ + "static/media/lcs_txt@2x.61be5d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lcs_txt@2x.png
// module id = 1796
// module chunks = 0 1